export default {
  header: {
    back: 'return',
    title: 'change password'
  },
  label: {
    resetPay: 'change payment password',
    resetPass: 'change login password',
    oldPasswd: 'old password',
    newPasswd: 'new password',
    reNewPasswd: 'confirm new password',
    bindgoogle: 'google authenticator'
  },
  placeholder: {
    oldPasswd: 'old password',
    newPasswd: 'new password',
    reNewPasswd: 'confirm new password',
    bindgoogle: 'google authenticator'
  },
  rules: {
    oldPasswd: {
      required: 'old password can not be empty！',
      format: 'Incorrect password format！'
    },
    newPasswd: {
      required: 'new password can not be empty！',
      format: 'Incorrect password format！',
      format1:
        'Please enter the correct password, which consists of 8-20 characters of numbers + uppercase and lowercase letters, for example: 123456Abcd'
    },
    reNewPasswd: {
      required: 'confirm new password can not be empty！',
      format: 'Incorrect password format！',
      same: 'New passwords and confirm new passwords do not match',
      format1:
        'Please enter the correct password, which consists of 8-20 characters of numbers + uppercase and lowercase letters, for example: 123456Abcd'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/passwd.js